module.exports = __webpack_public_path__ + "img/Mobile-Burger.4573e216.svg";